import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserShortInfo } from "../../types";
import ManShortSelector from "../../components/ui/shortItemSelect";
import {
  libBackend,
  backend,
  taskBackend,
  TaskCreationData,
  InviteLinkCreationData,
  Role,
  GroupListData,
} from "../../services";
import { actions, RootState } from "../../state/reducer";
import { toast } from "sonner";
import DateInput from "../../components/ui/dateInput";
import { generateRandomString } from "../../utils";

interface ModalLoaderProps {
  user_id: number;
  group_id?: number;
  role_id?: number;
  group_role_id?: number;
  onSave: () => void;
  closeModal: () => void;
}

const UpdateUserSettingsModal: React.FC<ModalLoaderProps> = ({
  user_id,
  group_id,
  role_id,
  group_role_id,
  onSave,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const [roles, setRoles] = useState<Role[]>([]);
  const [groups, setGroups] = useState<GroupListData[]>([]);
  const [linkData, setLinkData] = useState<InviteLinkCreationData>({
    name: "Новая",
    group_id: group_id || 0,
    group_role_id: group_role_id || 2,
    role_id: role_id || 0
  })

  useEffect(() => {
    backend.getRoleList().then((res) => {
     setRoles(res.roles)
   }).catch((e) => {
     toast("Не удалось загрузить список ролей")
   })
   backend.getGroupsList().then((res) => {
     setGroups(res.groups)
   }).catch((e) => {
     toast("Не удалось загрузить список групп")
   })
 }, [])


  const saveAction = async () => {
    return new Promise((resolve) => {

      backend
        .updateUserStatusByAdmin({...linkData, user_id})
        .then(() => {
          toast("Настройки сохранены");
          dispatch(actions.selectItem(generateRandomString(3)))
          resolve(true);
        })
        .catch(() => {
          toast("Ошибка сохранения настроек");
          resolve(false);
        });
    });
  };

  const closeWithSave = async () => {
    console.log("Сохраняем...")
    if (linkData.group_id === 0 || linkData.role_id === 0) {
        toast("Укажите группу и роль");
        return;
    }
    await saveAction();
    onSave(); // Передаем новое фото в callback
    closeModal(); // Закрываем модальное окно
  };

  return (
    <div className="creationForm">
      <div className="modalHeading">
        <h3>Создание ссылки на регистрацию</h3>
      </div>
      <form className="columnCenter">
        {/* Поле: Название задачи */}
        <div className="formField formRow">
          <label htmlFor="title">Группа:</label>
          <select
              id="group_id"
              name="group_id"
              value={linkData.group_id}
              onChange={(event) =>
                setLinkData((prev) => ({ 
                  ...prev,
                  group_id: Number(event.target.value)
                }))
              }
            >
              <option value="0" disabled>не указана</option>
              {groups.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
        </div>

        <div className="formField formRow">
          <label htmlFor="title">Роль в системе:</label>
          <select
              id="role_id"
              name="role_id"
              value={linkData.role_id}
              onChange={(event) =>
                setLinkData((prev) => ({ 
                  ...prev,
                  role_id: Number(event.target.value)
                }))
              }
            >
              <option value="0" disabled>не указана</option>
              {roles.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
        </div>
        <div className="formField formRow">
          <label htmlFor="title">Роль в группе:</label>
          <select
              id="group_role_id"
              name="group_role_id"
              value={linkData.group_role_id}
              onChange={(event) =>
                setLinkData((prev) => ({ 
                  ...prev,
                  group_role_id: Number(event.target.value)
                }))
              }
            >
              <option value="2">Участник</option>
              <option value="1">Владелец</option>
            </select>
        </div>
        {/* Кнопки действий */}
        <div className="flex between btnRow">
          <button
            className="filterButton"
            type="button"
            onClick={closeWithSave}
          >
            Сохранить
          </button>
          <button className="cancelButton" type="button" onClick={closeModal}>
            Отменить
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateUserSettingsModal;
